import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import Swal from "sweetalert2";
import Header from "../../../src/component/Header";
import IconDelete from "../../../src/component/SvgIcons/IconDelete";
import IconUpdownFilter from "../../../src/component/SvgIcons/IconUpdownFilter";
import api from "../../Services/api"; // Axios instance

import Pagination from "../../component/Pagination";
import Eye from "../../component/SvgIcons/Eye";
import IconSearch from "../../component/SvgIcons/IconSearch";
import { formatCountryDate } from "../../Services/countryTime";
export default function JobCandidate() {  
  const [careers, setCareers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
   const [itemsPerPage, setItemsPerPage] = useState(10);  
  
    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth >= 1920) {
          setItemsPerPage(20);
        } else {
          setItemsPerPage(10);
        }
      };
      handleResize(); // Set initial value
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);


  useEffect(() => {
    fetchCareers();
  }, []);

  // Fetch Careers from API
  const fetchCareers = async () => {
    try {
      const response = await api.post("/getviewcareers"); // Ensure correct endpoint
      setCareers(response.data);
    } catch (error) {
      console.error("Error fetching careers:", error);
    }
  };

  // Handle Search
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  // Handle Sorting
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedCareers = [...careers].sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "asc" ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  // Filter Careers
  const filteredJobPostCareers = sortedCareers.filter((career) => {
    const formattedDate = formatCountryDate(career.DateTime)
      .replace(/\//g, "-");  
    return (
      formattedDate.includes(searchQuery) ||
      career.FirstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      career.LastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      career.AppEmail.toLowerCase().includes(searchQuery.toLowerCase()) ||
      career.ContactNo.toLowerCase().includes(searchQuery.toLowerCase()) ||
      career.Address.toLowerCase().includes(searchQuery.toLowerCase()) ||
      career.ApplyFor.toLowerCase().includes(searchQuery.toLowerCase()) ||
      career.DocumentCV.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCareers = filteredJobPostCareers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredJobPostCareers.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Handle Delete Career
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this career?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      await api.post(`/careersdelete/${id}`);
      setCareers(careers.filter((career) => career.Id !== id));
      Swal.fire("Deleted!", "Career deleted successfully.", "success");
    } catch (error) {
      console.error("Error deleting career:", error);
      Swal.fire("Error", "Failed to delete career.", "error");
    }
  };

  return (
    <section className='eventpage'>
      <Header pageTitle="View Candidate List"/>
      <div className='pageLeftspace'>
      <div className="d-flex justify-content-between align-items-center topsearchbar">
      <div className="d-flex align-items-center gap-2">
       <Link to="#" onClick={() => handleSort("FirstName")}>
          <IconUpdownFilter />
        </Link>
      </div>

      <div className="input-container">
        <input
          type="text"
          id="search"
          placeholder="Search Here.."
          value={searchQuery}
          onChange={handleSearchChange}
        />
        {/* <label htmlFor="password">Search here..</label> */}
        <span className="underline"></span>
        <div className="search-icon">
          <IconSearch />
        </div>
      </div>

          </div>
          

        <div className="tableheader d-flex flex-column gap-4">
          <div className='event-detailstable'>
            <table className="table">
              <thead>
                <tr>
                <th width="10px" align="center">Sr. No.</th>
                <th>
                  Date
                  </th>
                  <th>Name</th>                  
                  <th>Email </th>
                  <th>Contact No.</th>
                  <th>Address </th>
                  <th>Apply For Position</th>
                  <th>CV </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentCareers.length > 0 ? (
                  currentCareers.map((career, index) => (
                    <tr key={career.Id}>
                      <td align="center">{index + 1}</td>
                      <td> {formatCountryDate(career.DateTime).replace(/\//g, "-")}</td>                      
                      <td>{career.FirstName} {career.LastName}</td>                      
                      <td>{career.AppEmail}</td>
                      <td>{career.ContactNo}</td>
                      <td>{career.Address}</td>
                      <td>{career.ApplyFor}</td>
                      <td data-tooltip-id={`blog-tooltip-${career.Id}`} data-tooltip-content={career.DocumentCV ? career.DocumentCV.replace(/<\/?[^>]+(>|$)/g, "") : ""}>
                        {career.DocumentCV
                          ? (career.DocumentCV.replace(/<\/?[^>]+(>|$)/g, "").length > 20
                            ? `${career.DocumentCV.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 50)}...`
                            : career.DocumentCV.replace(/<\/?[^>]+(>|$)/g, ""))
                          : ""}

                        <Tooltip
                          id={`blog-tooltip-${career.Id}`}
                          place="top"
                          effect="solid"
                          style={{ whiteSpace: 'normal', maxWidth: '400px' }}
                        />
                      </td>
                      <td>
                        <div className='action'>
                          <Link
                            to={`${process.env.REACT_APP_API_PRJ_URL}${career.fullCVUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="editbtn"
                           data-tooltip-id={`view-${career.fullCVUrl}`}
                           data-tooltip-content="View CV"
                          >
                            <Eye />
                          </Link>
                          <Tooltip id={`view-${career.fullCVUrl}`} place="top" />

                          <Link to="#" onClick={() => handleDelete(career.Id)}
                          data-tooltip-id={`delete-${career.id}`}
                          data-tooltip-content="Delete">
                            <IconDelete />
                          </Link>

                          <Tooltip id={`delete-${career.id}`} place="top" />
                         

                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" style={{ textAlign: "center", padding: "10px" }}>
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          
         {/* Pagination */}
         <Pagination
            currentPage={currentPage}
            totalPages={filteredJobPostCareers.length > itemsPerPage ? totalPages : 0}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}
